import { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../../components/ui/table";
import { useNavigate } from "react-router";

const apiUrl = process.env.REACT_APP_API_URL;

export default function ReasonsTaskNotCompletedTable() {
  const token = localStorage.getItem("token");
  const [reasonsTaskNotCompleted, setReasonsTaskNotCompleted] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchWorkflowCategories = async () => {
    const response = await fetch(`${apiUrl}/reasons_task_not_completed`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    })
    const result = await response.json();
    console.log(result);
    if (result.success) {
      setReasonsTaskNotCompleted(result.reasonsTaskNotCompleted);
    } else {
      setReasonsTaskNotCompleted([]);
    }
  };

  useEffect(() => {
    fetchWorkflowCategories();
  }, []);

  const handleRowClick = (reason: any) => {
    navigate(`/update-reason-task-not-completed`, { state: { reason } });
  }

  return(
    <>
      <Table>
        <TableHeader className="bg-[#d9ffa3]">
          <TableRow>
            <TableCell isHeader className="px-4 py-3 border border-gray-100 dark:border-white/[0.05]">
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex gap-3">
                  <span className="font-semibold text-gray-700 text-theme-xs dark:text-gray-400">
                    Name
                  </span>
                </div>
              </div>
            </TableCell>
          </TableRow>
        </TableHeader>
        <TableBody>
          {reasonsTaskNotCompleted.map((reason) => (
            <TableRow key={reason.actaskreason_id} className="cursor-pointer hover:bg-[#ffffa3]"  onClick={() => handleRowClick(reason)}>
              <TableCell className="px-4 py-4 font-normal text-gray-800 border border-gray-100 dark:border-white/[0.05] text-xs dark:text-gray-400 whitespace-normal">
                <span>{reason.name}</span>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  )
}